import toast from "react-hot-toast";
import i18n from "../i18n";

const FORBIDDEN_TOAST_ID = "fh-forbidden";
const CAREER_READ_ONLY_TOAST_ID = "fh-career-read-only";

/** FH-221/FH-244: the backend's code for a write refused on a read-only career profile. */
export const CAREER_READ_ONLY_CODE = "career_read_only";

let activeRouteKey = "";

export function setForbiddenToastRoute(pathname: string) {
  if (pathname !== activeRouteKey) {
    activeRouteKey = pathname;
    toast.dismiss(FORBIDDEN_TOAST_ID);
    toast.dismiss(CAREER_READ_ONLY_TOAST_ID);
  }
}

/** True when a 403 body says the career profile is read-only for this user. */
export function isCareerReadOnlyBody(data: unknown): boolean {
  return !!data && typeof data === "object" && (data as { code?: unknown }).code === CAREER_READ_ONLY_CODE;
}

export function showForbiddenToastOnce(data?: unknown) {
  if (isCareerReadOnlyBody(data)) {
    toast.error(i18n.t("errors.careerReadOnly"), { id: CAREER_READ_ONLY_TOAST_ID });
    return;
  }
  toast.error(i18n.t("errors.forbidden"), { id: FORBIDDEN_TOAST_ID });
}
